var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup35788(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35788",
    transform: "translate(-677 -1498)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 346",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(677 1498)",
    style: {
      opacity: 0.2,
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34610"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41375",
    d: "M942.779 63.515h5.623a1.735 1.735 0 0 1 1.875 1.858v5.478c0 .474-.224.748-.592.738s-.561-.271-.561-.733V65.45c0-.594-.183-.779-.768-.78h-11.138c-.6 0-.783.182-.783.765v11.171c0 .56.193.75.763.75H942.787a.578.578 0 0 1 .57.578.567.567 0 0 1-.576.57c-.468.014-.937 0-1.405 0h-4.253a1.728 1.728 0 0 1-1.838-1.822V65.33a1.727 1.727 0 0 1 1.839-1.821l5.655.006z",
    transform: "translate(-250.779 1441.986)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41376",
    d: "M952.509 81.049a8.93 8.93 0 0 1-1.4.476 2.525 2.525 0 0 1-2.864-2.128 2.575 2.575 0 0 1 2.144-2.927 2.522 2.522 0 0 1 2.908 2.182 4.042 4.042 0 0 1-.145 1.282c-.045.2-.032.3.128.419.4.3.788.619 1.175.937a.514.514 0 0 1 .146.753.528.528 0 0 1-.79.041c-.465-.362-.92-.73-1.302-1.035zm-1.735-3.573a1.512 1.512 0 0 0-1.528 1.513 1.536 1.536 0 0 0 1.53 1.553 1.552 1.552 0 0 0 1.537-1.523 1.534 1.534 0 0 0-1.539-1.543z",
    transform: "translate(-255.204 1437.566)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41377",
    d: "M945.247 70.992h-4.078c-.525 0-.838-.322-.674-.682.13-.284.421-.344.756-.343h7.417c.207 0 .415-.005.621 0 .432.015.688.211.688.518s-.255.5-.692.5c-1.346.01-2.692.007-4.038.007z",
    transform: "translate(-253.219 1439.409)",
    style: {
      fill: "#5f7d95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41378",
    d: "M942.364 76.173h-1.312c-.372 0-.592-.207-.583-.528s.221-.493.583-.495q1.3-.006 2.591 0a.514.514 0 1 1 0 1.023c-.427.005-.853 0-1.279 0z",
    transform: "translate(-252.747 1437.338)",
    style: {
      fill: "#5f7d95"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35788);
export default __webpack_public_path__ + "static/media/Group35788.c5c6ff50bf381758b2eda9b15f5fbac3.svg";
export { ForwardRef as ReactComponent };